import { FC } from "react";
import { Typography, useTheme } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledWrapper = styled("div")(() => ({
  marginBottom: 27,

  "& > h1": {
    marginTop: 2,
  },
}));

interface ColumnHeaderProps {
  overline: string;
  title: string;
}

const ColumnHeader: FC<ColumnHeaderProps> = ({ overline, title }) => {
  const theme = useTheme();
  return (
    <StyledWrapper>
      <Typography color={theme.colors.black} variant="overline">
        {overline}
      </Typography>
      <Typography variant="h1">{title}</Typography>
    </StyledWrapper>
  );
};

export default ColumnHeader;
